export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SCIENCE: "/science",
  TEAM: "/team",
  UPDATES: "/updates",
  UPDATE_DETAIL: "/updates/:slug",
  GET_INVOLVED: "/get-involved",
  NOT_FOUND: "/404",
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = (typeof ROUTES)[RouteKey];

export const NAV_ITEMS = [
  { labelKey: "nav.home", path: ROUTES.HOME },
  { labelKey: "nav.project", path: ROUTES.ABOUT },
  { labelKey: "nav.science", path: ROUTES.SCIENCE },
  { labelKey: "nav.team", path: ROUTES.TEAM },
  { labelKey: "nav.updates", path: ROUTES.UPDATES },
  { labelKey: "nav.getInvolved", path: ROUTES.GET_INVOLVED },
] as const;

export function isActiveRoute(currentPath: string, routePath: string): boolean {
  if (routePath === "/") return currentPath === "/";
  return currentPath === routePath || currentPath.startsWith(`${routePath}/`);
}

export * from "./locale";
